import { Checkbox, message,Descriptions,Avatar } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { SERVER_ADDRESS } from '../../../Config/Config';
import adminAvatar from '../../../assets/images/avatars/adminProfile.png'

const AdminProfile = () => {
  const [user,setUser] = useState({})
  const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
  const privelges = ["create","verification","delete","edit","subscription","suspend"]

  useEffect(()=>{
    fetchUser()
  },[])

  const fetchUser = async()=>{
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/getAdmin`,{id:userData.id})
      if(response.status === 200){
        setUser(response.data.data)
      } 
    } catch (error) {
      message.error({content:"Something Went Wrong !"})
    }
  }
  const items = [
    {
      key:"1",
      label:"Profile",
      children:<Avatar shape='square' src={adminAvatar} size={40} />
    },
    {
      key:"2",
      label:"User Name",
      children:<p>{user.name}</p>
    },
    {
      key:"3",
      label:"Email",
      children:<p>{user.email}</p>
    },
    {
      key:"4",
      label:"Role",
      children:<p>{user.role}</p>
    },
    {
      key:"5",
      label:"Priveleges",
      children:<p>{privelges.map((privelege)=>(
        <Checkbox key={privelege}  checked={userData.privelege.includes(privelege)} disabled >
          {privelege.charAt(0).toUpperCase()+privelege.slice(1)}
        </Checkbox>
      ))}</p>
    },
    
  ]

  return (
    <>
    <div style={{marginTop:"5rem",padding:"3rem",borderRadius:"1rem",backgroundColor:"white"}} >
      <Descriptions title={`${user.name} Info`} items={items} />
    </div>
    </>
  )
}

export default AdminProfile